module.exports = __webpack_public_path__ + "static/img/logo1.2.0ddb1517.png";